import VueCookies from "vue-cookies";

// Configuration options
const defaultOptions = {
  expires: "1d",
  domain: process.env.NODE_ENV === "production" ? ".matta.trade" : "localhost",
  path: "/",
  secure: process.env.NODE_ENV === "production",
  sameSite: "Strict",
};

export const cookieUtils = {
  /**
   * Set a cookie with the given name and value
   * @param {string} name - Cookie name
   * @param {any} value - Cookie value
   * @param {Object} options - Optional cookie settings
   */
  set(name, value, options = {}) {
    const cookieOptions = { ...defaultOptions, ...options };
    VueCookies.set(
      `${name}_Staging`,
      value,
      cookieOptions.expires,
      cookieOptions.path,
      cookieOptions.domain,
      cookieOptions.secure,
      cookieOptions.sameSite
    );
  },

  /**
   * Get a cookie value by name
   * @param {string} name - Cookie name
   * @returns {any} Cookie value or null if not found
   */
  get(name) {
    return VueCookies.get(`${name}_Staging`);
  },

  /**
   * Check if a cookie exists
   * @param {string} name - Cookie name
   * @returns {boolean}
   */
  has(name) {
    return VueCookies.isKey(`${name}_Staging`);
  },

  /**
   * Remove a specific cookie
   * @param {string} name - Cookie name
   * @param {Object} options - Optional cookie settings (domain and path must match original)
   */
  remove(name, options = {}) {
    const cookieOptions = { ...defaultOptions, ...options };
    VueCookies.remove(
      `${name}_Staging`,
      cookieOptions.path,
      cookieOptions.domain
    );
  },

  /**
   * Remove all cookies
   * @param {Object} options - Optional cookie settings (domain and path must match original)
   */
  removeAll(options = {}) {
    const cookieOptions = { ...defaultOptions, ...options };
    const allCookies = VueCookies.keys();

    allCookies.forEach((cookieName) => {
      VueCookies.remove(cookieName, cookieOptions.path, cookieOptions.domain);
    });
  },

  /**
   * Get all cookie names
   * @returns {string[]} Array of cookie names
   */
  getAllCookieNames() {
    return VueCookies.keys();
  },
};

export default cookieUtils;
